<template>
    <v-card>
        <v-card-title class="primary white--text"  style="height: 52px;  padding: 0px;">
            <v-btn icon @click="cancelDialog()"><v-icon class="white--text">close</v-icon></v-btn>
            <div class="title tf_title_dialog">{{ $t('searchVisitor') }}</div>
            <v-spacer></v-spacer>
            <v-btn v-if="$vuetify.breakpoint.smAndDown" flat @click="submitDialogCreateIntention()" class="white--text">{{ $t('submit') }}</v-btn>
        </v-card-title>
        <v-card-text>
          <v-text-field
            autofocus
            required
            :label="$t('name')"
            v-model="newSearchVisitor.name"
            v-on:keyup.enter="onEnter"
          >
          </v-text-field>

          <v-layout
            align-center
            row
            fill-height
            v-if="loading"
          >
            <div class="text-xs-center">
              <v-progress-circular indeterminate class="primary--text" :size="100" :width="3"></v-progress-circular>
            </div>
          </v-layout>

          <v-layout
            style="max-height: 250px; overflow: auto;"
            align-left
            row
            fill-height
            v-else
          >
            <div>
              <template v-for="(visitor, i) in listeVisiteurs">
                <div
                  v-if="visitor.error == 1"
                  :key="i"
                >{{$t('Saisissez un nom de visiteur recherché')}}</div>
                <div
                  v-else-if="visitor.error == 0"
                  :key="i"
                >{{$t('Aucun visiteurs trouvés')}}</div>
                <wz-watcheebox-visiteur
                  v-else
                  :key="i"
                  :datasVisiteur="visitor"
                  :visSelectId="visiteurChatSelected"
                  :searchVisitor="true"
                  @openChat="showChat"
                ></wz-watcheebox-visiteur>
              </template>
            </div>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click.native="cancelDialog()">{{ $t('cancel') }}</v-btn>
          <v-btn color="primary" flat @click.native="submitSearchVisitor()">{{ $t('search') }}</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
// import _ from 'lodash'
import {mapState} from 'vuex'
import monitor from '../../mixins/monitor'
import _ from 'lodash'
export default {
  mixins: [monitor],
  data () {
    return {
      listeVisiteurs: null,
      newSearchVisitor: {name: ''},
      loading: false,
      error: false
    }
  },
  mounted () {},
  updated () {},
  computed: {
    ...mapState('_StoreWatcheeBox', [
      'visiteurChatSelected'
    ])
  },
  methods: {
    cancelDialog () {
      this.$emit('closeDialog')
    },
    onEnter () {
      // console.log('recherche enter')
      this.submitSearchVisitor()
    },
    showChat (visiteurInfos) {
      this.$emit('openChat', visiteurInfos)
    },
    // ----------------------------------------------------------------------------
    // recherche les infos visiteur
    // ----------------------------------------------------------------------------
    submitSearchVisitor () {
      this.loading = true
      if (this.newSearchVisitor.name !== '') {
        console.log('this.newSearchVisitor.name', this.newSearchVisitor.name)
        let name = this.newSearchVisitor.name
        console.log('recherche visiteur listeAllVisiteurs', this.listeAllVisiteurs)
        // filtre le tableau des visiteurs avec le nom recherché
        let listeFilter = _.filter(this.listeAllVisiteurs, function (o) {
          return o.visiteurName.indexOf(name) !== -1
        })
        console.log('listeFilter', listeFilter)
        if (listeFilter.length) {
          this.listeVisiteurs = listeFilter
          this.loading = false
        } else {
          this.listeVisiteurs = [{error: '0'}]
          this.loading = false
        }
      } else {
        this.listeVisiteurs = [{error: '1'}]
        this.loading = false
      }
      console.log('listeVisiteurs', this.listeVisiteurs)
    }
  },
  watch: {},
  filters: {}
}
</script>

<style scoped>
  .tf_title_dialog {
    text-overflow: ellipsis;
    width: calc(100% - 180px);
    overflow: hidden;
    white-space: nowrap;
  }
</style>



// WEBPACK FOOTER //
// src/components/watcheebox/WzSearchVisitor.vue